import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/account';
import _ from 'lodash';
import { Modal, Alert, Space, Input, Empty } from '@bedrock/components';
import NoResults from '@bedrock/components/es/Empty/images/middle/NoResults'
import clx from 'classnames';
import { BuildingFilled, Check } from '@bedrock/icons-react';
import './index.less';
import { WithViewBaseConfigProvider } from '@mpc/common/src/features/PxToRemWrapper';


interface ChangeSupplierModalProps {
  getSuppliersList: Function;
  chooseSupplier: Function;
  onChangeVisible: Function;
  visible: boolean;
  showClose: boolean;
  suppliersList: Array<Record<string, any>>;
  prefixCls?: string;
  isOpenNotification: (flag: boolean) => void
}

class ChangeSupplierModal extends React.Component<
  ChangeSupplierModalProps,
  any
> {

  public static defaultProps = {
    showClose: true,
    visible: false,
    prefixCls: 'mpc-external-supplier-choose',
  };

  constructor(props: ChangeSupplierModalProps) {
    super(props);

    this.state = {
      inputValue: '',
      showModal: false,
      submitLoading: false,
      newSuppliersList: [],
      selectedId: null,
    };
  }

  componentDidUpdate(prevProps: Readonly<ChangeSupplierModalProps>, prevState: Readonly<any>): void {
    const { visible, suppliersList } = this.props;
    if (!prevProps.visible && visible) {
    const newSuppliersList = suppliersList.map(v => {
      if (v.is_new) {
        return {
          ...v,
          full_name: `${v.full_name}-${v.channel_type_name}`
        }
      } else {
        return {
          ...v,
          full_name: `${v.full_name}-${v.id}`
        }
      }
    })
      const item = newSuppliersList.find((v) => v?.selected);
      this.setState({
        selectedId: item ? item?.id : null,
        newSuppliersList,
      });
    }
  }

  // componentDidMount(): void {
  //   const { suppliersList } = this.props;
  //   console.log(suppliersList,'suppliersList')
  //   const newSuppliersList = suppliersList.map(v => {
  //     if (v.is_new) {
  //       return {
  //         ...v,
  //         full_name: `${v.full_name}-${v.channel_type_name}`
  //       }
  //     } else {
  //       return {
  //         ...v,
  //         full_name: `${v.full_name}-${v.id}`
  //       }
  //     }
  //   })
  //   this.setState({ newSuppliersList })
  // }

  public handleModalSubmit = () => {
    const { selectedId } = this.state;
    const { onChangeVisible, isOpenNotification } = this.props;
    this.setState({ submitLoading: true });
    this.props
      .chooseSupplier({
        supplier_id: selectedId,
      })
      .then(() => {
        window.location.href = '/';
      })
      .finally(() => {
        this.setState({ submitLoading: false });
        if (onChangeVisible) {
          isOpenNotification(true)
          onChangeVisible(false);
        }
      });
  }

  public handleChoose(id: number) {
    this.setState({
      selectedId: id,
    });
  }

  public handleInputChange(v: string) {
    this.setState({
      inputValue: v,
    });
  }

  public handleClose() {
    const { showClose, onChangeVisible } = this.props;
    if (showClose) {
      onChangeVisible && onChangeVisible(false);
    }
  }

  // public handleSearch() {
  //   const { suppliersList } = this.props;
  //   const { inputValue } = this.state
  //   const filterSuppliers = suppliersList.filter((v: any) => {
  //     return v.full_name.indexOf(inputValue) > -1;
  //   });
  // }

  public render() {
    const { visible, showClose, suppliersList, prefixCls } = this.props;
    const { submitLoading, selectedId, inputValue, newSuppliersList } = this.state;
    const filterSuppliers = newSuppliersList.filter((v: any) => {
      return v.full_name.indexOf(inputValue) > -1;
    });
    return (
      <WithViewBaseConfigProvider>
      <Modal
        title="选择供应商"
        className='change-supplier-modal'
        width={520}
        onOk={() => this.handleModalSubmit()}
        onCancel={() => this.handleClose()}
        confirmLoading={submitLoading}
        visible={visible}
        destroyOnClose
        cancelButtonProps={{
          style: { display: showClose ? 'initial' : 'none' },
        }}
        closable={showClose}
        maskClosable={false}
      >
        <div className={prefixCls}>
          <Alert showIcon type="warning" className={`${prefixCls}-alert`}
            message="系统检测到您的账号关联多家供应商，请选择本次登录的供应商。"
          />
          <Input.Search
            className={`${prefixCls}-input`}
            value={inputValue}
            size='large'
            style={{
              width: '100%',
              marginBottom: 24,
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              this.handleInputChange(e.target.value)
            }}
            placeholder="请输入供应商名称"
          />
          {filterSuppliers?.length ? <div className={`${prefixCls}-list`}>
            <Space direction="vertical" size={12}>
              {filterSuppliers.map((supplier: any, index) => (
                <div
                  key={supplier.id}
                  className={clx(`${prefixCls}-item`, {
                    [`${prefixCls}-item-active`]: supplier.id === selectedId,
                  })}
                  onClick={() => this.handleChoose(supplier.id)}
                >
                  <div style={{ display: 'flex' }}><BuildingFilled />{supplier.full_name}</div>
                  {supplier.id === selectedId && <div><Check /></div>}
                </div>
              ))}
            </Space>
          </div> : <Empty text="暂无搜索结果" imageNode={<NoResults />} />}
        </div>
      </Modal>
      </WithViewBaseConfigProvider>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return { suppliersList: state.account.suppliersList };
};

const mapDispatchToProps = (dispatch: Dispatch<actions.AccountActions>) => {
  return bindActionCreators(
    {
      getSuppliersList: actions.getSuppliersList,
      chooseSupplier: actions.chooseSupplier,
      isOpenNotification: actions.isOpenNotification,
    },
    dispatch,
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangeSupplierModal);
